const useListWithPagination = (list) => {
  const orderedList =
    list?.reduce((acc, current, index) => {
      if (index % 9 === 0) {
        acc.push([])
      }
      acc[acc.length - 1].push(current)
      return acc
    }, []) || []
  return [orderedList]
}

export default useListWithPagination
